import {
    DynamicAdPlacement,
    DynamicFunnelReports,
    DynamicSpiderCharts,
    ReportMetricsPerDateChart,
    ReportMetricsPerDateTable
} from "@components";
import { History, Location } from "history";
import * as React from "react";
import { connect } from "react-redux";
import { ChartPlaceholder } from "./ChartPlaceholder";
import { ReportLayout } from "./ReportLayout";

export interface DynamicReportsPageProps {
    history: History;
    location: Location;
}

const DynamicReportsPageComponent = (props: DynamicReportsPageProps) => {
    return (
        <ReportLayout history={props.history} location={props.location} subtitle="Dynamic performance">
            <DynamicFunnelReports />
            <ChartPlaceholder size="full">
                <ReportMetricsPerDateChart />
            </ChartPlaceholder>
            <ChartPlaceholder size="full">
                <ReportMetricsPerDateTable />
            </ChartPlaceholder>
            <ChartPlaceholder size="full">
                <DynamicAdPlacement />
            </ChartPlaceholder>
            <ChartPlaceholder size="full">
                <DynamicSpiderCharts />
            </ChartPlaceholder>
        </ReportLayout>
    );
};

export const DynamicReportsPage = connect((_, ownProps: DynamicReportsPageProps) => ownProps)(
    DynamicReportsPageComponent
);
